export default __webpack_public_path__ + "static/media/loadingLogo.4219d15f.svg";